import { Button, ButtonProps, createPolymorphicComponent } from "@mantine/core"
import styled from '@emotion/styled'
import { NavLink } from "react-router-dom"
import { IconNames } from "src/components/ui/Icons"

type TopBarNavButtonProps = {
    to: string
    label: string
    icon: IconNames | string;
    onClick?(): void
}

const _StyledButton = styled(Button)`
    & .mantine-Button-label {
        [data-mantine-color-scheme='light'] & {
            color: var(--mantine-color-gray-6);
        }
        [data-mantine-color-scheme='dark'] & {
            color: var(--mantine-color-dark-7);
        }
    }      
    &.active {        
        [data-mantine-color-scheme='light'] & {
            /* background-color: var(--mantine-color-gray-3); */
            background-color: var(--mantine-color-dark-9);
        }
        [data-mantine-color-scheme='dark'] & {
            background-color: var(--mantine-color-dark-9);
        }
        & .mantine-Button-label {
            [data-mantine-color-scheme='light'] & {
                /* color: var(--mantine-color-dark-9); */
                color: var(--mantine-color-white);
            }
            [data-mantine-color-scheme='dark'] & {
                color: var(--mantine-color-white);
            }          
        }
    }    
    
`
const StyledButton = createPolymorphicComponent<'button', ButtonProps>(_StyledButton);

export const TopBarNavButton: React.FC<TopBarNavButtonProps> = ({ to, label, onClick }) => {
    return (
        <StyledButton
            variant="subtle"
            color="text-primary"
            to={to}
            component={NavLink}
            onClick={onClick}
        >
            {label}
        </StyledButton>
    )
}